export function waitClientSync(gl: WebGL2RenderingContext, callback: () => void) {
	const sync = gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE, 0)

	const checkSync = () => {
		if (!sync) {
			callback()
			return
		}

		const status = gl.clientWaitSync(sync, 0, 0)

		switch (status) {
			case gl.TIMEOUT_EXPIRED:
				// Not completed. Check again.
				return requestAnimationFrame(checkSync)
			case gl.WAIT_FAILED:
			case gl.ALREADY_SIGNALED:
			case gl.CONDITION_SATISFIED:
			default:
				// Rendering complete
				gl.deleteSync(sync)
				callback()
		}
	}

	requestAnimationFrame(checkSync)
}
